import { Hidden } from '@mui/material'
import cn from 'classnames'
import Image from 'next/image'
import Link from 'next/link'
import React from 'react'
import HomeBuyVendorBadge from 'src/components/global/HomeBuyVendorBadge/HomeBuyVendorBadge'
import { IconButton } from 'src/components/global/IconButton/IconButton'
import * as enVariables from 'src/config/config'

import eventfooterImg from '../../assets/eventfooter.png'
interface EventFooterProps {
  className?: string
}

/**
 * Primary UI component for user interaction
 */
export const EventFooter: React.FC<EventFooterProps> = ({ className }) => {
  return (
    <div className={cn(className, 'flex flex-row justify-center bg-clouds')}>
      <div className="px-[1.25rem] !max-w-[1100px] w-full flex flex-row items-center py-2">
        <div className="grid py-4 gap-[5rem] sm:grid-cols-2 justify-between">
          <Hidden mdDown>
            <div className="md:float-left">
              <Image className="" src={eventfooterImg} alt="" />
            </div>
          </Hidden>
          <div className="self-center float-right">
            <HomeBuyVendorBadge />
            <div className="pt-[0.5rem] pb-[0.625rem] text-[1.5rem] font-bold font-secondary text-[#222222]">
              Submit an Event
            </div>
            <div className="text-[1.125rem] font-primary font-regular text-darkgray">
              If you are the organizer of an event that is not yet listed, submit the details here and your event will
              be listed if it meets the criteria for inclusion (legal tech or innovation).
            </div>
            <Link href={`mailto:${enVariables.CONTACT_URL}?subject=Submit an event`} target="_blank">
              <IconButton type="primary" label="Submit Event" className="w-[9.625rem] pt-5" />
            </Link>
          </div>
        </div>
      </div>
    </div>
  )
}
